
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sqlserver",
      function () {
        return require("private-next-pages/destinations/sqlserver.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sqlserver"])
      });
    }
  